import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

const CheckboxField = ({ label, name, onChange }) => {
  const [field, , helpers] = useField({ name });

  const handleChange = (event) => {
    helpers.setValue(event.target.checked);
    onChange();
  };

  return <FormControlLabel control={<Checkbox checked={field.value} onChange={handleChange} name={field.name} />} label={label} />;
};

CheckboxField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CheckboxField;
